<template>
  <div class="wrapper daftarkan-masjid">
    <div class="donation-detail">
      <div
        class="main-content bg-white"
        style="padding: 15px; padding-top: 100px;"
      >
        <img src="/img/mohonmaaf.png" alt="" class="terimakasih mt-5" />
        <p class="notice-text mt-3">
          Maaf, <br />
          Halaman yang anda cari tidak kami temukan.<br />
          Silahkan masukan alamat yang benar.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    buatLaporanBaru() {
      const ref_code = this.$route.params.ref_code;

      this.$router.push({
        name: "laporkan-form",
        params: {
          ref_code,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 0px;
  min-height: calc(100vh - 0px);
}

.terimakasih {
  display: block;
  position: relative;
  margin: 0 auto;
  height: 220px;
}

.notice-text {
  text-align: center;
}

.btn-main {
  display: block;
  position: relative;
  margin: 0 auto;
  width: 80%;
}
</style>
